import React from 'react';
import { motion, TargetAndTransition } from 'framer-motion';

import { ArrowProps } from './ArrowProps';
import * as styles from './Arrow.module.scss';

const bounceAnimation: TargetAndTransition = {
	y: 5,
	transition: {
		repeat: Infinity,
		duration: 1,
		repeatType: 'reverse',
	},
};

export const Arrow: React.FC<ArrowProps> = ({
	width = 2,
	height = 84,
	animation = 'none',
	transform = 'translateX(-44%) rotate(45deg)',
}) => {
	return (
		<motion.div
			animate={animation === 'bounce' && bounceAnimation}
			style={{ width, height }}
			className={styles.line}
		>
			<div style={{ transform }} className={styles.arrow} />
		</motion.div>
	);
};
